/** @format */

import React, {
  FunctionComponent,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
  useMemo
} from 'react'
import TablePage from '../TablePage'
import { _$, Select, Option, Checkbox, Message, Icon } from '@king-design/react'
import _ from 'lodash'
import request from 'src/utils/request'
import styled from 'styled-components'
import API from 'src/api/ApiContacts'

interface ReciverProps {
  ref?: any
  defaultValue?: any[]
  selectContainer?: string
  className?: string
  onChange?: (value: any[]) => void
}

export interface AlarmReciverRef {
  getRecivers: () => {
    contactId: string
    contactName: string
    contactFlag: number // 1: 联系组 2: 联系人
    contactWay: number // 0: 不通知 1: 邮箱 2: 短信 3: 短信+邮箱
  }[]
}

export const handelConcatData = data => {
  const dealList = _.cloneDeep(data)
  const filterHide = dealList.filter(item => !item?.hide)
  const filterWay = filterHide.filter(item => item.contactWay !== 0)
  // const filterId = filterHide.filter(item => !item.contactId)
  if (filterHide.length > filterWay.length) {
    Message.error(_$('告警联系人请勾选通知方式'))
    return false
  } else {
    return filterWay.map(item => {
      return {
        contactID: item.contactId,
        contactName: item.contactName,
        contactFlag: item.contactFlag,
        contactWay: item.contactWay
      }
    })
  }
}

const AlarmReciver: FunctionComponent<ReciverProps> = forwardRef(
  ({ defaultValue, selectContainer, className, onChange }, ref) => {
    const userList = useRef<any[]>()
    const groupList = useRef<any[]>()
    const [concatData, setData] = useState([])
    // 获取联系人 & 联系组接口请求
    const getReciverList = async () => {
      const { data: userlist } = await request(API.getAlertUser, {
        method: 'get',
        data: {
          PageIndex: 1,
          Cap: 1
        }
      })
      const { data: usergrplist } = await request(API.getUserGroup, {
        method: 'get',
        data: {
          PageIndex: 1,
          Cap: 1
        }
      })
      userList.current = Array.isArray(userlist?.userlist)
        ? userlist?.userlist.map(i => ({ label: i?.name, value: i?.userid }))
        : []
      groupList.current = Array.isArray(usergrplist?.usergrplist)
        ? usergrplist?.usergrplist.map(i => ({ label: i?.name, value: i?.usrgrpid }))
        : []
      return {
        userlist: userList.current,
        userGrpList: groupList.current
      }
    }

    useImperativeHandle(ref, () => ({
      getRecivers: () => {
        const dealList = _.cloneDeep(concatData)
        const filterHide = dealList.filter(item => !item?.hide)
        const filterWay = filterHide.filter(item => item.contactWay !== 0)
        const filterId = filterHide.filter(item => !item.contactId)
        if (filterId?.length) {
          Message.error(_$('请选择告警联系人/联系组'))
          return false
        } else if (filterHide.length > filterWay.length) {
          Message.error(_$('告警联系人请勾选通知方式'))
          return false
        } else {
          return filterWay.map(item => {
            return _.pick(item, ['contactId', 'contactName', 'contactFlag', 'contactWay'])
          })
        }
      }
    }))

    const resetConcatData = (index, id) => {
      concatData[index]['contactId'] = id
      const list = concatData.map((item, i) => {
        const filterOptions = item.options.filter(el => el?.value !== id)
        if (i !== index) {
          return {
            ...item,
            options: filterOptions
          }
        }
        return { ...item }
      })
      setData(list)
      onChange && onChange(handelConcatData(list))
    }

    const resetFlag = (type, index, value) => {
      const list = _.cloneDeep(concatData)
      const currentWay = list[index].contactWay
      if ((currentWay === 1 || currentWay === 2) && value === true) {
        list[index].contactWay = 3
      } else if (currentWay === 0 && value) {
        list[index].contactWay = type === 'message' ? 2 : 1
      } else if (currentWay === 3 && !value) {
        list[index].contactWay = type === 'message' ? 1 : 2
      } else {
        list[index].contactWay = 0
      }
      setData(list)
      onChange && onChange(handelConcatData(list))
    }
    const scheme = {
      contactName: {
        title: _$('接收人'),
        width: '50%',
        template: function (item, index) {
          const options = _.cloneDeep(item.options)
          return (
            <Select
              style={{ width: '98%' }}
              value={concatData[index].contactId}
              placeholder={item.contactFlag === 1 ? _$('请选择联系组') : _$('请选择联系人')}
              container={
                selectContainer
                  ? selectContainer
                  : dom => {
                      if (document.getElementsByClassName('custom-alarm-drawer')[0]) {
                        return document
                          .getElementsByClassName('custom-alarm-drawer')[0]
                          .getElementsByClassName('k-dialog-body')[0]
                      }
                    }
              }
              onChangeValue={id => resetConcatData(index, id)}
            >
              {options?.length
                ? options
                    .filter(opt => {
                      const hasIds = concatData.filter(i => !i?.hide).map(i => i.contactId)
                      return (
                        opt?.value === concatData[index].contactId || !hasIds.includes(opt?.value)
                      )
                    })
                    .map((i, index) => (
                      <Option value={i?.value} key={i?.value || index}>
                        {i?.label}
                      </Option>
                    ))
                : null}
            </Select>
          )
        }
      },
      contactWay: {
        title: _$('通知方式'),
        width: '30%',
        minWidth: 100,
        template: function (item, index) {
          const way = item.contactWay
          return (
            <>
              <Checkbox
                value={way === 2 || way === 3 ? true : false}
                onChangeValue={value => resetFlag('message', index, value)}
              >
                {_$('短信')}
              </Checkbox>
              <Checkbox
                onChangeValue={value => resetFlag('email', index, value)}
                style={{ marginLeft: '8px' }}
                value={way === 1 || way === 3 ? true : false}
              >
                {_$('邮箱')}
              </Checkbox>
            </>
          )
        }
      },
      action: {
        title: _$('操作'),
        width: '20%',
        minWidth: 100,
        template: function (item, index) {
          return <a onClick={() => delData(item, index)}>{_$('删除')}</a>
        }
      }
    }

    // 添加列表数据
    const addData = type => {
      // const hasIds = concatData.filter(i => !i?.hide).map(i => i.contactId)
      // 判断添加联系人或联系组
      const options = type === 'group' ? groupList.current : userList.current
      // 过滤已添加的联系人或联系组
      // const filterOptions = options.filter(i => !hasIds.includes(i?.value))
      const list = _.cloneDeep(concatData)
      const addItem = {
        contactFlag: type === 'group' ? 1 : 2, // 1 表示添加组 ； 2 表示添加用户
        contactId: '',
        contactName: '',
        contactWay: 3,
        options
      }
      const addIndex = list.length
      list.push({ ...addItem, index: addIndex })
      setData(list)
      onChange && onChange(handelConcatData(list))
    }

    // 删除列表数据
    const delData = (item, index) => {
      const delItem = item.options.find(i => i?.value === item?.contactId)
      const list = _.cloneDeep(concatData)
      list[index].hide = true
      list.forEach((el, i) => {
        if (i !== index) {
          el.options = el?.options?.concat(delItem)
        }
      })
      setData(list)
      onChange && onChange(handelConcatData(list))
    }

    // 设置默认值
    const dealDefaultData = (defaultValue, userlist, userGrpList) => {
      const defaultUser = defaultValue.map(item => {
        if (item.contactFlag === 1) {
          item.options = userGrpList
          item.contactName = userGrpList.find(i => i.value === item.contactId)?.['label']
        } else {
          item.options = userlist
          item.contactName = [].concat(userlist).find(i => i.value === item.contactId)?.['label']
        }
        return item
      })
      setData(defaultUser)
      // onChange && onChange(defaultUser)
    }
    useEffect(() => {
      if (!defaultValue?.length) return
      if (userList.current?.length > 0 && groupList.current?.length > 0) {
        dealDefaultData(defaultValue, userList.current, groupList.current)
      } else {
        getReciverList().then(res => {
          const { userlist = [], userGrpList = [] } = res || {}
          userList.current = userlist
          groupList.current = userGrpList
          dealDefaultData(defaultValue, userlist, userGrpList)
        })
      }
    }, [defaultValue])

    const contcatDataLen = useMemo(() => {
      if (!concatData?.length) {
        return 0
      } else {
        return concatData.filter(item => !item.hide).length
      }
    }, [concatData])

    return (
      <div className={className}>
        {contcatDataLen > 0 ? (
          <TablePage
            tableProps={{
              scheme: scheme,
              checkType: 'none',
              noDataTemplate: _$('暂无数据'),
              data: concatData,
              rowClassName: value => (value.hide ? 'hide-row' : '')
            }}
            style={{ marginTop: 0 }}
          />
        ) : null}
        <p style={{ margin: 0, lineHeight: '32px' }}>
          <a
            onClick={() => {
              if (!concatData?.length) {
                getReciverList().then(res => {
                  addData('group')
                })
              } else {
                addData('group')
              }
            }}
          >
            <Icon color="#0091ea" className="ion-plus-round"></Icon>
            {_$('添加联系组')}
          </a>

          <a
            onClick={() => {
              if (!concatData?.length) {
                getReciverList().then(res => {
                  addData('users')
                })
              } else {
                addData('users')
              }
            }}
            style={{ marginLeft: '16px' }}
          >
            <Icon color="#0091ea" className="ion-plus-round"></Icon>
            {_$('添加联系人')}
          </a>
        </p>
      </div>
    )
  }
)

export default styled(AlarmReciver)`
  .ion-plus-round {
    margin-right: 4px;
    font-size: 14px;
  }
`
